<template lang="pug">
  v-hover.px2( v-slot:default="{ hover }" )
    v-list-item
      v-list-item-icon( v-if='elemento.codigo')
        v-chip.mr-1(color='primary') {{elemento.codigo|| ''}} 
      v-list-item-content
        span(v-if="!agregar_codigo_input") {{elemento.descripcion}} 
        v-text-field(
          v-if="agregar_codigo_input"
          v-model="elemento.codigo"
          label='Código'
          autofocus      
        )
      v-list-item-action( @click.stop )
        v-row
          v-tooltip( v-if='requiere_codigo && hover' v-model="eliminar_codigo_tooltip" bottom)
            template( v-slot:activator="{ on }")
              v-btn( x-small v-on='on' @click.stop.prevent="eliminar({arreglo, elemento})" icon)
                v-icon( x-small ) far fa-trash-alt 
            span Eliminar
          v-tooltip( v-if='!agregar_codigo_input && requiere_codigo && hover' v-model="agregar_codigo_tooltip" bottom)
            template( v-slot:activator="{ on }")
              v-btn( v-on='on' x-small @click.stop.prevent="agregar_codigo_input = !agregar_codigo_input" icon)
                v-icon( x-small ) fa-plus 
            span Agregar código 
          v-tooltip( v-if='agregar_codigo_input && requiere_codigo && hover' v-model="agregar_codigo_tooltip" bottom)
            template( v-slot:activator="{ on }")
              v-btn( v-on='on' x-small @click.stop.prevent="actualizar_codigo({arreglo, elemento}); agregar_codigo_input=false" icon)
                v-icon( x-small ) fa-save 
            span Guardar 
      
</template>
<script>
import {mapActions} from 'vuex'
export default {
  data: ()=> ({
    agregar_codigo_tooltip: false,
    eliminar_codigo_tooltip: false,
    agregar_codigo_input: false,
  }),
  props:{
    arreglo: String,
    elemento: Object,
    requiere_codigo: Boolean
  },
  methods:{
    ...mapActions({
      actualizar_codigo: 'Arreglos/actualizar_codigo',
      eliminar: 'Arreglos/eliminar',
    }),
  },
}
</script>